import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["preloaderHeight", "query", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import Preloader from "../../../Preloader";
import { arrowsDefaultProps, arrowsPropTypes, basicDefaultProps, basicPropTypes, opacityLayerDefaultProps, opacityLayerPropTypes, switchDefaultProps, switchPropTypes } from "./props";
import { FrameSwitcherEventHandler } from "./EventHandler";
import { adjustDurationToNumber, adjustFramesDimensions, adjustRemoveNoTransition, filterFrame, filterOther, filterStatic, queryReducer } from "../../utils";

/**
 * This component is some sort of props builder.
 *
 * - It builds function to calculate actual props depending on width and height
 * - It splits `children` prop to 3 parts: `Frame`, `StaticContent` and other
 */
export var FrameSwitcher = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FrameSwitcher, _React$PureComponent);
  var _super = _createSuper(FrameSwitcher);
  function FrameSwitcher() {
    var _this;
    _classCallCheck(this, FrameSwitcher);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isLoading: true
    });
    _defineProperty(_assertThisInitialized(_this), "reference", null);
    _defineProperty(_assertThisInitialized(_this), "bindReference", function (ref) {
      _this.reference = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "controlBinder", function (controlName) {
      return function () {
        if (_this.reference && _this.reference[controlName]) {
          var _this$reference;
          (_this$reference = _this.reference)[controlName].apply(_this$reference, arguments);
        }
      };
    });
    // Scroll controlls
    // CAUTION! Storing this functions may couse memory leaks
    _defineProperty(_assertThisInitialized(_this), "showSlide", _this.controlBinder('showSlide'));
    _defineProperty(_assertThisInitialized(_this), "showLeft", _this.controlBinder('showLeft'));
    _defineProperty(_assertThisInitialized(_this), "showRight", _this.controlBinder('showRight'));
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
        preloaderHeight = _this$props.preloaderHeight,
        query = _this$props.query,
        children = _this$props.children,
        props = _objectWithoutProperties(_this$props, _excluded);
      var isLoading = _this.state.isLoading;

      // computing props
      var getProps = [/** @deprecated Will be removed in v2.0.0 */
      adjustRemoveNoTransition, /** @deprecated Will be removed in v2.0.0 */
      adjustDurationToNumber, adjustFramesDimensions].reduceRight(function (acc, next) {
        return next(acc);
      }, queryReducer(query, props));
      var frames = filterFrame(children);
      if (isLoading) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            position: 'relative',
            height: "".concat(preloaderHeight, "px")
          }
        }, /*#__PURE__*/React.createElement(Preloader, null), /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'none'
          }
        }, frames));
      }
      return /*#__PURE__*/React.createElement(FrameSwitcherPropBuilder, {
        frames: frames,
        getProps: getProps,
        ref: _this.bindReference,
        static: filterStatic(children)
      }, filterOther(children));
    });
    return _this;
  }
  _createClass(FrameSwitcher, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      setTimeout(function () {
        _this2.setState({
          isLoading: false
        });
      }, 50);
    }
  }]);
  return FrameSwitcher;
}(React.PureComponent);

/**
 * This component is some sort of props builder.
 *
 * - It builds actual props depending on `query` prop and View dimensions
 * - It handles width and height changes
 */
_defineProperty(FrameSwitcher, "defaultProps", _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basicDefaultProps), arrowsDefaultProps), opacityLayerDefaultProps), switchDefaultProps), {}, {
  preloaderHeight: 400,
  children: null,
  query: []
}));
FrameSwitcher.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basicPropTypes), arrowsPropTypes), opacityLayerPropTypes), switchPropTypes), {}, {
  /**
   * Preloader wrapper height
   */
  preloaderHeight: PropTypes.number,
  /**
   * Support CSS time string as value
   * @deprecated CSS time string support will be removed in v2.0.0.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Support CSS time string as value
   * @deprecated CSS time string support will be removed in v2.0.0.
   */
  autoSwitchTime: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node.isRequired,
  /**
   * This is array of rules to apply to props. It's functionality very similar to CSS media query.
   *
   * Every element in array should be plain object that contains `test` function and other data
   * similar to component props. If `test` functioin return `true` then data will be applied.
   *
   * `test` function accepts 2 arguments: component width & component height and should return
   * `true` or `false`.
   * test is funciton of this.state.width.
   *
   * @example
   * ```javascript
   * [
   *    {test: w => w => 200, a: 30},
   *    {test: (w, h) => h => 200, b: 30},
   *    {test: (w, h) => w => 300 && h => 300, c: 30},
   * ]
   * ```
   *
   * @usage
   * ```jsx
   * <Comp a={10} b={20} query={[
   *    {test: w => w => 200, a: 30},
   *    {test: (w, h) => h => 200, b: 30},
   *    {test: (w, h) => w => 300 && h => 300, c: 30},
   * ]}/>
   *
   * // It'll be
   * <Comp a={10} b={20} /> // When `width < 200` && `height < 200`
   * <Comp a={30} b={20} /> // When `200 <= width < 300` && `height < 200`
   * <Comp a={10} b={30} /> // When `width < 200` && `200 <= height < 300`
   * <Comp a={30} b={30} /> // When `200 <= width < 300` && `200 <= height < 300`
   * <Comp a={30} b={30} c={30} /> // When `width >= 300` && `height >= 300`
   * ```
   */
  query: PropTypes.arrayOf(PropTypes.shape(_objectSpread(_objectSpread({}, basicPropTypes), {}, {
    test: PropTypes.func.isRequired
  })))
}) : {};
var FrameSwitcherPropBuilder = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(FrameSwitcherPropBuilder, _React$PureComponent2);
  var _super2 = _createSuper(FrameSwitcherPropBuilder);
  function FrameSwitcherPropBuilder() {
    var _this3;
    _classCallCheck(this, FrameSwitcherPropBuilder);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this3 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this3), "state", {
      width: 0,
      height: 0
    });
    _defineProperty(_assertThisInitialized(_this3), "getDimensions", function (wrapperWidth, wrapperHeight) {
      var _this3$state = _this3.state,
        width = _this3$state.width,
        height = _this3$state.height;
      if (width !== wrapperWidth || height !== wrapperHeight) {
        _this3.setState({
          width: wrapperWidth,
          height: wrapperHeight
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this3), "reference", null);
    _defineProperty(_assertThisInitialized(_this3), "bindReference", function (ref) {
      _this3.reference = ref;
    });
    _defineProperty(_assertThisInitialized(_this3), "controlBinder", function (controlName) {
      return function () {
        if (_this3.reference && _this3.reference[controlName]) {
          var _this3$reference;
          (_this3$reference = _this3.reference)[controlName].apply(_this3$reference, arguments);
        }
      };
    });
    // Scroll controlls
    // CAUTION! Storing this functions may couse memory leaks
    _defineProperty(_assertThisInitialized(_this3), "showSlide", _this3.controlBinder('showSlide'));
    _defineProperty(_assertThisInitialized(_this3), "showLeft", _this3.controlBinder('showLeft'));
    _defineProperty(_assertThisInitialized(_this3), "showRight", _this3.controlBinder('showRight'));
    _defineProperty(_assertThisInitialized(_this3), "render", function () {
      var computedProps = _this3.props.getProps(_this3.state.width, _this3.state.height);
      return /*#__PURE__*/React.createElement(FrameSwitcherEventHandler, _extends({}, computedProps, {
        frames: _this3.props.frames,
        onResize: _this3.getDimensions,
        placeholderWidth: _this3.state.width,
        ref: _this3.bindReference,
        static: _this3.props.static
      }), _this3.props.children);
    });
    return _this3;
  }
  return _createClass(FrameSwitcherPropBuilder);
}(React.PureComponent);
_defineProperty(FrameSwitcherPropBuilder, "defaultProps", {
  children: null,
  static: null
});
FrameSwitcherPropBuilder.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  frames: PropTypes.node.isRequired,
  static: PropTypes.node,
  getProps: PropTypes.func.isRequired
} : {};